import { call, put, takeLatest } from "redux-saga/effects";
import { actions } from "./slice";
import * as APIS from "../../../../../services/apis";

export function* handleFetchDropdown({ payload }) {
  try {
    const res = yield call(APIS.fetchDropdown, payload);
    const { data } = res;
    yield put(actions.fetchDropdownSuccess(data));
  } catch (err) {
    yield put(actions.fetchDropdownFailure(err?.response?.data));
  }
}

export function* handleFetchCountries({ payload }) {
  try {
    const res = yield call(APIS.fetchAllCountries, payload);
    const { data } = res;
    yield put(actions.fetchCountriesSuccess(data));
  } catch (err) {
    yield put(actions.fetchCountriesFailure(err?.response?.data));
  }
}

export function* handleFetchStates({ payload }) {
  try {
    const res = yield call(APIS.fetchAllStatesByCountryId, payload);
    const { data } = res;
    yield put(actions.fetchStatesSuccess(data));
  } catch (err) {
    yield put(actions.fetchStatesFailure(err?.response?.data));
  }
}

export function* handleFetchCities({ payload }) {
  try {
    const res = yield call(APIS.fetchAllCitiesByStateId, payload);
    const { data } = res;
    yield put(actions.fetchCitiesSuccess(data));
  } catch (err) {
    yield put(actions.fetchCitiesFailure(err?.response?.data));
  }
}

export function* handleUpdateCompany({ payload }) {
  try {
    const res = yield call(APIS.updateCompany, payload);
    const { data } = res;
    yield put(actions.updateCompanySuccess(data));
    payload.onSuccess();
  } catch (err) {
    if (err?.response?.status === 500)
      yield put(
        actions.updateCompanyFailure({
          message: "Something has gone wrong on the web site's server.",
        })
      );
    else yield put(actions.updateCompanyFailure(err?.response?.data));
    payload.onFailure();
  }
}

export function* handleFetchCompanyDetails({ payload }) {
  try {
    const res = yield call(APIS.fetchCompanyDetails, payload);
    const { data } = res;
    yield put(actions.fetchCompanyDetailsSuccess(data));
  } catch (err) {
    yield put(actions.fetchCompanyDetailsFailure(err?.response?.data));
  }
}
/**
 * Root saga manages watcher lifecycle
 */
export function* companyEditSaga() {
  yield takeLatest(actions.fetchCompanyDetails.type, handleFetchCompanyDetails);
  yield takeLatest(actions.fetchDropdown.type, handleFetchDropdown);
  yield takeLatest(actions.fetchCountries.type, handleFetchCountries);
  yield takeLatest(actions.fetchStates.type, handleFetchStates);
  yield takeLatest(actions.fetchCities.type, handleFetchCities);
  yield takeLatest(actions.updateCompany.type, handleUpdateCompany);
}
